import { GetFinanceServicesFinancetypesApi } from "@/features/accounts/finance/services/get-services-financetypes-api";
import { GetFinanceServicesFinancetypesRequestModel } from "@/features/accounts/finance/services/get-services-financetypes-model";

/// 銀行口座種別取得処理
export class GetFinanceServicesFinancetypesService {
  private getFinanceServicesFinancetypesApi = new GetFinanceServicesFinancetypesApi();

  /**
   * 銀行口座種別取得API実行
   */
  public async getFinanceServicesFinancetypes(param: GetFinanceServicesFinancetypesRequestModel) {
    return await this.getFinanceServicesFinancetypesApi.getFinanceServicesFinancetypes(param);
  }
}
